import {
    validateImageBinaryResource,
    validatePdfBinaryResource,
    validatePlyBinaryResource,
    validateStlBinaryResource,
} from '../helpers/binaryResourceValidators';

const VIEWER_BINARY_RESOURCE_TYPES = Object.freeze({
    pdf: Object.freeze({
        accept: 'application/pdf',
        cacheKind: 'pdf',
        validateResource: validatePdfBinaryResource,
    }),
    thumbnail: Object.freeze({
        accept: 'image/*',
        cacheKind: 'thumbnail',
        validateResource: validateImageBinaryResource,
    }),
    texture: Object.freeze({
        accept: 'image/jpeg',
        cacheKind: 'texture',
        validateResource: validateImageBinaryResource,
    }),
    'geometry-stl': Object.freeze({
        accept: 'application/sla',
        cacheKind: 'geometry',
        validateResource: validateStlBinaryResource,
    }),
    'geometry-ply': Object.freeze({
        accept: 'application/sla',
        cacheKind: 'geometry',
        validateResource: validatePlyBinaryResource,
    }),
});

function createUnknownResourceTypeError(type) {
    return new Error(`Unknown viewer binary resource type "${type}".`);
}

export function getViewerBinaryResourceTypeDefinition(type) {
    const typeDefinition = VIEWER_BINARY_RESOURCE_TYPES[type];

    if (!typeDefinition) {
        throw createUnknownResourceTypeError(type);
    }

    return typeDefinition;
}

export function getViewerBinaryCacheKindFromType(type) {
    return getViewerBinaryResourceTypeDefinition(type).cacheKind;
}

export function normalizeViewerBinaryCacheRequest(request = {}) {
    const resolvedType = request.type || null;

    if (!resolvedType) {
        return {
            ...request,
            cacheKind: null,
            type: null,
            validateResource: request.validate,
        };
    }

    const typeDefinition = getViewerBinaryResourceTypeDefinition(resolvedType);

    return {
        ...request,
        accept: request.accept || typeDefinition.accept,
        cacheKind: typeDefinition.cacheKind,
        type: resolvedType,
        validateResource: request.validate || typeDefinition.validateResource,
    };
}
